// extracted by css-extract-rspack-plugin
export default {"name":"iZCnh4Mh5YUnGRwk"};